import React from 'react';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { NodePartner } from '../../../../types/uncinc_profile/nodes';

import './style.scss';

interface NodePartnersPageProps {
  entity: ImmutableEntity<NodePartner>;
}

const NodePartnerPage: React.FC<NodePartnersPageProps> = ({ entity }) => {
  const partner = entity.toJS();
  const title = partner.title[0].value;

  return (
    <div className="NodePartnerPage">
      {title}
    </div>
  );
};

export default NodePartnerPage;
